<div class="cart-list-container" *ngFor="let item of items; trackBy: trackById">
  <div class="cart-item">
    <div class="item-details">
      <div class="item-name">{{ item.menuItem.name | formattedLanguage : item.menuItem.translation }}</div>
      <div class="price" *ngIf="item.menuItem.price > 0">{{ item.menuItem.price | currency}}</div>
          <div class="item-description">
            <label *ngIf="item.portion"
              >Size: {{ item.portion.name }} <br
            /></label>
            <ng-container *ngFor="let modifier of item?.cartModifiers">
              <div *ngIf="modifier?.cartModifierItems?.length">
                <ng-container
                  *ngFor="
                    let modifierItem of modifier?.cartModifierItems;
                    index as i
                  "
                >
                  <ng-container
                    *ngIf="modifierItem?.cartModifierItem?.name && i == 0"
                    >{{ modifier.cartModifier.name }}:
                    {{ modifierItem.cartModifierItem.name }}</ng-container
                  >
                  <ng-container
                    *ngIf="modifierItem?.cartModifierItem?.name && i > 0"
                    >, {{ modifierItem.cartModifierItem.name }}</ng-container
                  >
                  <ng-container
                    *ngIf="modifierItem?.cartModifierSubItems?.length"
                  >
                    <ng-container
                      *ngFor="
                        let modifierSubItem of modifierItem?.cartModifierSubItems;
                        index as j
                      "
                    >
                      <ng-container
                        *ngIf="
                          modifierSubItem?.cartModifierSubItem?.name && j == 0
                        "
                      >
                        ({{
                          modifierSubItem.cartModifierSubItem.name
                        }}</ng-container
                      >
                      <ng-container
                        *ngIf="
                          modifierSubItem.cartModifierSubItem.name && j > 0
                        "
                        >,
                        {{
                          modifierSubItem.cartModifierSubItem.name
                        }}</ng-container
                      >
                      <ng-container
                        *ngIf="
                          modifierSubItem.cartModifierSubItem.name &&
                          j == modifierItem.cartModifierSubItems.length - 1
                        "
                        >)</ng-container
                      >
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>
          </div>
    </div>
    
    <div class="item-count-outer">
      <wj-item-count
        [menuitem]="item"
        [reviewmenuitem]="isReviewCart"
      >
      </wj-item-count>
      <div class="item-total" *ngIf="itemTotalPrice(item) > 0">
            {{ itemTotalPrice(item) | currency:CAD }}
      </div>
    </div>
    
  </div>
  <div
    class="edit-item"
    data-qa="list-cart-edit"
    aria-label="edit cart item"
    *ngIf="checkModifier(item)"
    (click)="editListCart(item)"
  >
    {{ 'edit-item' | translate }}
  </div>
</div>

<!-- <ng-container *ngIf="showModifier">
  <wj-modifier [itemDetail]="menuId" (closeModifier)="closeModal()" [isEdit]="true"></wj-modifier>
</ng-container> -->
